<template>
  <div class="agentVirtualAccounts">
    <header>
      {{ agentName }}
    </header>

    <h1>Virtual Accounts</h1>

    <div
      style="
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        gap: 1rem;
      "
    >
      <div
        style="
          display: flex;
          align-items: center;
          gap: 10px;
          margin-top: 0.1rem;
        "
      >
        <div class="" style="width: 100%; max-width: 360px">
          <input
            style="
              min-width: 250px;
              background-color: #f2f1ed;
              background-size: 18px 18px;
              border-radius: 24px;
              max-height: 50px;
              font-weight: 700;
              color: #9497b8;
            "
            type="text"
            class="form-control"
            placeholder="Searching...."
            v-model="searchQuery"
            @input="refresh('filter')"
          />
        </div>

        <div class="col-auto" style="margin-top: -0.8rem">
          <button
            type="submit"
            class="btn btn-primary mb-2 mt-4"
            style="background-color: #f2f1ed; color: #9497b8; border: none"
            @click="refresh('filter')"
          >
            <i class="fas fa-filter"></i>
            <i class="fas fa-solid fa-bars-filter"></i> Filter By
          </button>
        </div>

        <div class="col-auto mt-2">
          <div class="date-filter">
            <DatePicker
              style="width: 200px; border: none; background-color: #f2f1ed"
              v-model="dateRange"
              range
              :placeholder="['Start - End Date']"
              prefix-class="xmx"
              format="YYYY-MM-DD"
              @change="handleDateRangeChange"
            />
          </div>
        </div>
      </div>

      <div class="create-container">
        <button class="create-btn" @click="generate">
          <i class="fa fa-plus"></i>Create Virtual Account
        </button>
      </div>
    </div>
    <!-- Add Loading Spinner -->
    <div class="spinner-grow" role="status" v-if="loading === true"></div>

    <!-- <div v-if="errorMessage" class="error-message">
      {{ errorMessage }}
    </div> -->

    <div class="col-12">
      <card class="card-plain">
        <div class="table-full-width table-responsive table-container">
          <table class="table">
            <thead class="tms-dark">
              <tr>
                <th class="text-center">S/N</th>
                <th class="text-center">Bank Name</th>
                <th class="text-center">Account Name</th>
                <th class="text-center">Account Number</th>
                <th class="text-center">Terminal ID</th>
                <th class="text-center">Date Created</th>
                <th class="text-center">Action</th>
              </tr>
            </thead>

            <tbody>
              <tr v-if="accountDetails.length === 0">
                <td colspan="7" class="text-center">
                  <div class="no-accounts">
                    <img
                      src="@/assets/img/emptyvirtualaccount.png"
                      alt="No Accounts"
                    />
                    <h2>No Virtual Account Available</h2>
                    <p>
                      Create a Dedicated Virtual Account to receive direct bank
                      transfer payments from customer
                    </p>
                  </div>
                </td>
              </tr>
              <tr
                v-if="accountDetails.length > 0"
                v-for="(account, index) in accountDetails"
                :key="account.id"
              >
                <td class="text-center">{{ index + 1 }}</td>
                <td class="text-center">{{ account.bankName }}</td>
                <td class="text-center">{{ account.accountName }}</td>
                <td class="text-center">{{ account.accountNumber }}</td>
                <td class="text-center">{{ account.terminalId || "---" }}</td>
                <td class="text-center">{{ formatDate(account.createdAt) }}</td>
                <td class="text-center">
                  <span @click="openModal(account)" class="details"
                    >View Details</span
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </card>
    </div>

    <VirtualAccountModal
      :accountDetails="selectedAccount"
      :isVisible="showModal"
      :agentId="$route.params.agentId"
      @close="closeModal"
    />

    <CreateVirtualAccountModal
      :virtualAccount="virtualAccount"
      :isVisible="showCreateModal"
      @close="closeCreateModal"
    />
  </div>
</template>

<script>
import axios from "../store/axios";
import moment from "moment";
import VirtualAccountModal from "./Modals/VirtualAccountModal.vue";
import CreateVirtualAccountModal from "./Modals/CreateVirtualAccountModal.vue";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "../assets/css/datepicker.scss";
import Swal from "sweetalert2";

export default {
  components: {
    DatePicker,
    VirtualAccountModal,
    CreateVirtualAccountModal,
  },

  data() {
    return {
      accountDetails: [],
      selectedAccount: {},
      agentName: "",
      searchQuery: "",
      loading: false,
      error: false,
      errorMessage: "",
      showModal: false,
      terminalId: null,
      agentId: "",
      showCreateModal: false,
      virtualAccount: null,
    };
  },
  methods: {
    toggleDropdown(id) {
      this.accountDetails = this.accountDetails.map((account) => {
        if (account._id === id) {
          account.isDropdownOpen = !account.isDropdownOpen;
        } else {
          account.isDropdownOpen = false;
        }
        return account;
      });
    },

    formatDate(date) {
      return moment(date).format("YYYY.MM.DD hh:mm");
    },

    async refresh() {
      this.loading = true;
      this.error = false;

      try {
        const agentId = this.$route.params.agentId;

        // Verify that agentId exists
        if (!agentId) {
          throw new Error("Agent ID is missing in route parameters");
        }

        const payload = {
          agentId: agentId,
        };

        console.log("Fetching virtual accounts for agentId:", agentId);

        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}/get-virtual-accounts`,
          payload,
        );

        if (response.data && Array.isArray(response.data.accounts)) {
          if (response.data.status === "success") {
            this.accountDetails = response.data.accounts;
            this.applyFilters();
          } else if (response.data.status === "failed") {
            this.accountDetails = [];
          } else {
            this.loading = true;
          }
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.error = true;

        this.errorMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message;

        Swal.fire({
          icon: "error",
          title: "Error",
          html: `<b>${this.errorMessage}</b>`,
        });
      } finally {
        this.loading = false;
      }
    },

    applyFilters() {
      let filteredAccounts = this.accountDetails;

      if (this.searchQuery) {
        filteredAccounts = filteredAccounts.filter(
          (account) =>
            account.bankName
              .toLowerCase()
              .includes(this.searchQuery.toLowerCase()) ||
            account.accountName
              .toLowerCase()
              .includes(this.searchQuery.toLowerCase()),
        );
      }

      if (this.dateRange && this.dateRange.length === 2) {
        const [startDate, endDate] = this.dateRange;
        filteredAccounts = filteredAccounts.filter((account) => {
          const createdDate = moment(account.createdAt);
          return createdDate.isBetween(startDate, endDate, "day", "[]");
        });
      }

      this.accountDetails = filteredAccounts;
    },

    handleDateRangeChange(dateRange) {
      this.dateRange = dateRange;
      this.refresh("filter");
    },

    async generate() {
      this.loading = true;
      this.error = false;

      try {
        const agentId = this.$route.params.agentId;

        if (!agentId) {
          throw new Error("Agent ID is missing in route parameters");
        }

        const payload = { _id: agentId };

        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}/create-virtual-account-v2`,
          payload,
        );

        this.virtualAccount = response.data.accountDetails;
        this.showCreateModal = true;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.error = true;

        this.errorMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message;
        console.error("Error occurred while creating virtual account:", error);

        Swal.fire({
          icon: "error",
          title: "Error",
          html: `<b>${this.errorMessage}</b>`,
        });

        this.errorMessage = errorMessage;
      } finally {
        this.loading = false;
      }
    },

    async openCreateModal() {
      this.showCreateModal = true;
      console.log("Open create modal");
    },

    closeCreateModal() {
      this.showCreateModal = false;
      this.virtualAccount = null;
      console.log("Close create modal");
    },

    async openModal(account) {
      this.showModal = true;
      this.selectedAccount = account;
    },

    closeModal() {
      this.showModal = false;
      console.log("modal closed");
    },

    refreshTerminalId(newTerminalId) {
      this.selectedAccount.terminalId = newTerminalId;
    },
  },

  async mounted() {
    await this.refresh();
    const urlParams = new URLSearchParams(window.location.search);
    this.agentName = urlParams.get("name") || "";
  },
};
</script>

<style scoped>
.agentVirtualAccounts {
  background-color: #fff;
  padding: 40px 24px;
  border-radius: 8px 8px 0px 0px;
}

header {
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 24px;
  color: black;
  text-transform: capitalize;
}

h1 {
  color: black;
  font-size: 24px;
  font-weight: 700;
  margin: 0;
  margin-bottom: 24px;
}

.xmx-input {
  background-color: #f2f1ed !important;
}

.xmx-input {
  display: inline-block;
  box-sizing: border-box;
  width: 100%;
  height: 34px;
  padding: 6px 30px;
  padding-left: 10px;
  font-size: 14px;
  line-height: 1.4;
  color: #555;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
}

.create-container {
  display: flex;
  justify-content: end;
}

.create-btn {
  border: none;
  outline: none;
  background: #65b3c7;
  color: white;
  padding: 12px 16px;
  border-radius: 50px;
  font-size: 14px;
  font-weight: 600;
}

.no-accounts {
  padding: 80px 0;
  width: 100%;
  max-width: 360px;
  margin: auto;
}

.no-accounts h2 {
  font-size: 24px;
  font-weight: 600;
}

.no-accounts p {
  color: #9497b8;
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 22px;
}

.no-accounts button {
  border: none;
  outline: none;
  background: #65b3c7;
  color: white;
  font-weight: 600;
  padding: 12px 30px;
  font-size: 15px;
  border-radius: 50px;
}

.transaction {
  padding: 20px;
}

.details {
  color: #65b3c7;
  cursor: pointer;
}

.tms-dark {
  background-color: #333f48;
  color: #fff;
}

.spinner-grow {
  position: fixed;
}

.table-container {
  overflow-x: auto;
}

li {
  list-style: none;
}

.error-message {
  color: red;
  margin-top: 10px;
  font-size: 12px;
}

.error-message p {
  margin: 0;
}

.virtual-dropdown-list {
  background: white;
  position: absolute;
  border-radius: 8px;
  padding: 4px;
  width: max-content;
  font-size: 0.875rem;
  right: 0;
  box-shadow: 0 2px rgba(17, 16, 15, 0.1), 0 2px 10px rgba(17, 16, 15, 0.1);
  color: #23242f;
  text-align: left;
}
</style>
